import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {loadClubCaddies, submitReview} from "./async_actions";
import {ClubCaddie} from "../../../api/ClubCaddieService";

interface State {
    loading: boolean
    errMsg?: string
    clubId?: string
    caddies: ClubCaddie[]
    filteredCaddies: ClubCaddie[]
    session?: PostRoundSessionState
    urlParams: {
        caddieId?: string
        paymentId?: string
    }
}

interface PostRoundSessionState {
    caddie?: CaddieState,
    review: {
        rating: number,
        message: string,
        shareComment: boolean,
        attributes: string[],
    }
}

interface CaddieState {
    id: string
    name: string
    userId: string
}

const initialState: State = {
    loading: false,
    caddies: [],
    filteredCaddies: [],
    urlParams: {}
};

interface CaddieReviewLoadActionPayload {
    id: string
    userId: string
    name: string
}

export interface LoadClubCaddiesActionResponse {
    caddies: ClubCaddie[]
    filteredCaddies?: ClubCaddie[]
}

let slice = createSlice(
    {
        name: "PostRound",
        initialState: initialState,
        reducers: {
            handlePaymentIdFromUrl: (state, action: PayloadAction<string>) => {
                state.urlParams.paymentId = action.payload
                console.log('payment id from url set')
            },
            handleCaddieIdFromUrl: (state, action: PayloadAction<string>) => {
                state.urlParams.caddieId = action.payload
                console.log('caddie id from url set')
            },
            findSelectedCaddieFromUrl: (state) => {
                if (!state.urlParams.caddieId || !state.caddies) {
                    return;
                }

                let id = state.urlParams.caddieId
                let caddies = state.caddies.filter(c => c.caddieId === id)
                if (caddies.length === 1) {
                    let c = caddies[0]
                    state.session = {
                        caddie: {
                            id: id,
                            name: c.displayName,
                            userId: c.userId,
                        },
                        review: {
                            rating: 0,
                            message: "",
                            shareComment: false,
                            attributes: []
                        }
                    }
                }
            },
            handleCaddieReviewLoad: (state, action: PayloadAction<CaddieReviewLoadActionPayload>) => {
               state.session = {
                    caddie: {
                        id: action.payload.id,
                        name: action.payload.name,
                        userId: action.payload.userId,
                    },
                    review: {
                       rating: 0,
                       message: "",
                       shareComment: false,
                       attributes: []
                   }
               }
            },
            handleReviewMessageUpdated: (state, action: PayloadAction<string>) => {
                if (!state.session || !state.session.review) {
                    return;
                }
               state.session.review.message = action.payload
            },
            handleToggleShareComment: (state) => {
                if (!state.session || !state.session.review) {
                    return;
                }
               state.session.review.shareComment = !state.session.review.shareComment
            },
            handleToggleAttribute: (state, action: PayloadAction<string>) => {
                if (!state.session || !state.session.review) {
                    return;
                }

                let a = state.session.review.attributes

                if (a.includes(action.payload)) {
                    a = a.filter(attr => attr !== action.payload)
                } else {
                    a.push(action.payload)
                }

               state.session.review.attributes = a
            },
            handleRatingUpdated: (state, action: PayloadAction<number>) => {
                if (!state.session || !state.session.review) {
                    return;
                }

               state.session.review.rating = action.payload
            },
            handleClubCaddieFilter: (state, action: PayloadAction<string>) => {
                if (!action.payload) {
                    state.filteredCaddies = state.caddies
                    return;
                }

                state.filteredCaddies = state.caddies.filter(c => c.displayName.toLowerCase().includes(action.payload.toLowerCase()))
            },
        },
        extraReducers: (builder) => {
            builder.addCase(
                loadClubCaddies.fulfilled,
                (state, action: PayloadAction<LoadClubCaddiesActionResponse>) => {
                    if (action.payload.caddies) {
                        state.caddies = action.payload.caddies

                        state.filteredCaddies = action.payload.filteredCaddies ?
                            action.payload.filteredCaddies :
                            action.payload.caddies
                    }
                }
            )
            builder.addCase(
                submitReview.fulfilled,
                (state, action: PayloadAction<string | undefined>) => {
                    if (action.payload) {
                        state.errMsg = action.payload
                        return;
                    }

                    state.session = undefined
                    state.errMsg = undefined;
                }
            )
        }
    }
);

export const {
    handlePaymentIdFromUrl,
    handleCaddieIdFromUrl,
    findSelectedCaddieFromUrl,
    handleCaddieReviewLoad,
    handleReviewMessageUpdated,
    handleToggleShareComment,
    handleToggleAttribute,
    handleRatingUpdated,
    handleClubCaddieFilter,
} = slice.actions;

export default slice.reducer;